module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/4-313eb702e2e6a9061d34c91c9f749f06.jpg";